import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import CpdAnalyticsTab from './CpdAnalyticsTab';

interface CpdAnalyticsDialogProps {
  open: boolean;
  onClose: () => void;
  /** True for admins — unlocks the CSV/XLSX upload panel. */
  isAdmin?: boolean;
}

/**
 * "CPD Analytics" — standalone dashboard of CPD fulfilment across all agents.
 * Previously a tab inside Leader Verifications; now its own sidebar entry so it
 * can be deep-linked via /super-picker?redirect=cpd. The content component owns
 * its own loading, refresh and drill-down state.
 */
const CpdAnalyticsDialog: React.FC<CpdAnalyticsDialogProps> = ({ open, onClose, isAdmin = false }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="lg"
    fullWidth
    PaperProps={{
      sx: {
        bgcolor: 'var(--color-surface)',
        color: 'var(--color-text-strong)',
        minHeight: '80vh',
      },
    }}
  >
    <DialogTitle sx={{ borderBottom: '1px solid rgba(var(--color-text-rgb), 0.08)' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
        <Box>
          <Typography variant="h6">CPD Analytics</Typography>
          <Typography variant="body2" sx={{ color: 'rgba(var(--color-text-rgb), 0.72)' }}>
            CPD fulfilment across all agents — last week vs this week.
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>
    </DialogTitle>

    <DialogContent sx={{ pt: 2.5 }}>
      <CpdAnalyticsTab isAdmin={isAdmin} />
    </DialogContent>

    <DialogActions sx={{ borderTop: '1px solid rgba(var(--color-text-rgb), 0.08)' }}>
      <Button onClick={onClose}>Close</Button>
    </DialogActions>
  </Dialog>
);

export default CpdAnalyticsDialog;
